import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'
import ReactList from 'react-list'
import { GoTriangleDown, GoTriangleUp } from 'react-icons/go'

import { EmployeeItem } from './employee-item'

import { employeeSelector } from '../../../selectors'

import { FONTS } from '../../../constants'

const filterUsers = (list, keywordSearch) => {
  const keyword = keywordSearch.toLowerCase()
  if (keyword === '') return list.filter(l => !l.is_init_user)
  return list.filter(l => {
    const { emp_code, company, lob, name, nick_name, position } = l
    return (
      emp_code.toLowerCase().indexOf(keyword) > -1
    || company.toLowerCase().indexOf(keyword) > -1
    || lob.toLowerCase().indexOf(keyword) > -1
    || name.toLowerCase().indexOf(keyword) > -1
    || nick_name.toLowerCase().indexOf(keyword) > -1
    || position.toLowerCase().indexOf(keyword) > -1
    ) && !l.is_init_user
  })
}

export const DataTable = React.memo(({
  employeeList,
  activeItem,
  handleClickRow,
}) => {
  const sortColumn = [
    'emp_code',
    'company',
    'lob',
    'name',
    'nick_name',
    'position',
  ]
  const [sortOrder, setSortOrder] = useState({ col: 0, desc: false })
  const keywordSearch = useSelector(employeeSelector.getKeywordSearch)
  const users = orderBy(
    filterUsers(
      employeeList,
      keywordSearch
    ),
    sortColumn[sortOrder.col], sortOrder.desc ? 'desc' : 'asc'
  )

  const renderIcon = (col) => {
    if (sortOrder.col === col) {
      return sortOrder.desc ? <GoTriangleDown /> : <GoTriangleUp />
    }
    return null
  }

  const handleSort = (col) => {
    if (sortOrder.col === col) {
      setSortOrder({ ...sortOrder, desc: !sortOrder.desc })
    } else {
      setSortOrder({ col, desc: true })
    }
  }

  const renderItem = (index) => {
    const item = users[index]

    return (
      <EmployeeItem
        key={ item._id }
        item={ item }
        activeItem={ activeItem }
        handleClickRow={ handleClickRow }
      />
    )
  }

  return (
    <Root>
      <HeaderRow>
        <IDCol onClick={ () => handleSort(0) }>
          Emp ID
          {renderIcon(0)}
        </IDCol>
        <CompanyCol onClick={ () => handleSort(1) }>
          Company
          {renderIcon(1)}
        </CompanyCol>
        <LOBCol onClick={ () => handleSort(2) }>
          LOB
          {renderIcon(2)}
        </LOBCol>
        <NameCol onClick={ () => handleSort(3) }>
          Name
          {renderIcon(3)}
        </NameCol>
        <NicknameCol onClick={ () => handleSort(4) }>
          Nickname
          {renderIcon(4)}
        </NicknameCol>
        <PositionCol onClick={ () => handleSort(5) }>
          Position
          {renderIcon(5)}
        </PositionCol>
      </HeaderRow>
      <RowWrapper>
        <ReactList
          itemRenderer={ renderItem }
          length={ users.length }
        />
      </RowWrapper>
    </Root>
  )
})

const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const RowWrapper = styled.div`
  max-height: calc(100vh - 190px);
  overflow-y: scroll;
`

const Row = styled.div`
    min-height: 35px;
    height: auto;
    display: flex;
    align-items: center;
    padding: 8px 24px;
    background: #FFFFFF;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
    border-top: 1px solid #EAEAEA;
    cursor: pointer;

    :nth-child(1) {
        border: none;
    }

    :hover {
      background-color: rgba(0, 0, 0, 0.075);
    }
`

const HeaderRow = styled(Row)`
    background: #4F4F4F;
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.SMALL_SIZE};
    color: #FFFFFF;

    :hover {
      background: #4F4F4F;
    }
`

const IDCol = styled.div`
    flex: 1;
    padding: 0 8px;
    min-width: 0;
    word-wrap: break-word;

    svg {
      margin-left: 8px;
      font-size: 16px;
    }
`

const CompanyCol = styled(IDCol)`
    flex: 1;
`

const LOBCol = styled(IDCol)`
    flex: 1;
`

const NameCol = styled(IDCol)`
    flex: 2;
`

const NicknameCol = styled(IDCol)`
    flex: 1;
`

const PositionCol = styled(IDCol)`
    flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/data-table/index.js